<template>
  <v-col cols="auto">
    <v-img
      :gradient="isChosen ? 'to bottom right, rgba(0,0,0,.3), rgba(0,0,0,.2)' : ''"
      :src="file.url"
      :width="width"
      height="auto"
      lazy-src="@/assets/images/placeholder.png"
      aspect-ratio="1"
      class="grey lighten-2 pointer"
      style="border-radius: 10px"
      @click="$emit('choose-file', file.id)"
    >
      <v-btn v-if="pickerMode" icon>
        <v-icon>
          {{
            isChosen ? 'mdi-checkbox-marked-outline' : 'mdi-checkbox-unmarked-outline'
          }}
        </v-icon>
      </v-btn>
      <v-btn v-else-if="!hideDelete" icon @click.stop.prevent="$emit('remove-file', file.id)">
        <v-icon>mdi-close-circle-outline</v-icon>
      </v-btn>
      <template v-slot:placeholder>
        <v-row
          class="fill-height ma-0"
          align="center"
          justify="center"
        >
          <v-progress-circular
            indeterminate
            color="grey lighten-5"
          />
        </v-row>
      </template>
    </v-img>
    <slot name="body"/>
  </v-col>
</template>

<script>
export default {
  name: 'media-preview-IMAGE',
  props: {
    file: {
      type: Object,
      default: () => ({}),
      required: true
    },
    isChosen: {
      type: Boolean,
      default: false
    },
    hideDelete: {
      type: Boolean,
      default: false
    },
    pickerMode: {
      type: Boolean,
      default: false
    },
    width: {
      type: String,
      default: ''
    }
  }
}
</script>
